import React, { Component } from 'react';
import { FormGroup, Row, Col, Checkbox, FormControl } from 'react-bootstrap';
import FontAwesome from 'react-fontawesome';
import getContent from './Contents/Services';
import Select from '../Select';

export default class Services extends Component {
  options = () => ({
    producer: this.props.producer || '',
    engineering: this.props.engineering || false,
    mixing: this.props.mixing || false,
    production: this.props.production || false,
    masters: this.props.masters || '',
    artistName: this.props.artistName || '',
  });

  handleContent(field, value) {
    const options = this.options();
    options[field] = value;

    if (field === 'engineering' && value === true) {
      options.engineering = true;
    } else if (field === 'mixing' && value === true) {
      options.mixing = true;
    } else if (field === 'production' && value === true) {
      options.production = true;
    } else if (field === 'producer') {
      options.producer = value;
    } else if (field === 'masters') {
      if (value < 0) {
        return;
      }
      options.masters = value;
    } else if (field === 'artistName') {
      options.artistName = value;
    }

    this.props.updateBlock(this.props.block.id, getContent(options), options);
  }

  render() {
    const { members } = this.props;

    return (
      <div className="tab-content">
        <Row>
          <Col sm={12}>
            <p className="question">Which collaborator is the Producer?</p>
            <FormGroup className="answer">
              <Select
                className="form-control"
                value={this.props.producer}
                onChange={(e) => this.handleContent('producer', e.target.value)}
              >
                <option value="">Please select</option>
                {members.map((member, i) => {
                  if (member.user_info) {
                    let userName = member.user_info.name;
                    if (member.user_info.use_company_name) {
                      userName =
                        userName + ' (' + member.user_info.company_name + ')';
                    }
                    return (
                      <option key={i} value={member.user}>
                        {userName}
                      </option>
                    );
                  } else {
                    return null;
                  }
                })}
              </Select>
            </FormGroup>

            <p className="question">What services will the Producer provide?</p>
            <FormGroup className="answer">
              <Checkbox
                checked={this.props.engineering === true}
                readOnly
                onClick={(e) =>
                  this.handleContent('engineering', e.target.checked)
                }
              >
                Engineering
              </Checkbox>
              <Checkbox
                checked={this.props.mixing === true}
                readOnly
                onClick={(e) => this.handleContent('mixing', e.target.checked)}
              >
                Mixing
              </Checkbox>
              <Checkbox
                checked={this.props.production === true}
                readOnly
                onClick={(e) =>
                  this.handleContent('production', e.target.checked)
                }
              >
                Production
              </Checkbox>
            </FormGroup>

            <FormGroup className="answer">
              The Producer will produce&nbsp;&nbsp;
              <FormControl
                type="number"
                className="input-sm"
                placeholder="#"
                value={this.props.masters}
                onChange={(e) => this.handleContent('masters', e.target.value)}
              />
              &nbsp;&nbsp;master(s) in total that will be performed by&nbsp;
              <FormControl
                type="text"
                placeholder="Enter the name of the performance artist here"
                value={this.props.artistName}
                style={{ width: 340 }}
                onChange={(e) =>
                  this.handleContent('artistName', e.target.value)
                }
              />
            </FormGroup>
          </Col>

          <Col sm={12}>{this.props.children}</Col>

          <Col sm={12}>
            <div className="notes">
              <h4>
                <FontAwesome name="question-circle" />
                Need Some Help?
              </h4>
              <div className="expand" tabIndex="0">
                <p className="question">Why is this important?</p>
                <p className="small">
                  The "services" section is a description of the type of work
                  that will be done to create the master(s). Defining this
                  clears up any confusion about what work should be done.
                </p>
              </div>
              <div className="expand" tabIndex="1">
                <p className="question">What are masters?</p>
                <p className="small">
                  The term “master” usually refers to the original sound
                  recording of a performance from which copies can be made.
                </p>
              </div>
            </div>
          </Col>
        </Row>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// src/components/ContractBlock/Services.jsx